import { axios, axios2 } from '@/lib/axios';
import { AxiosResponse } from 'axios';
import { Feature, FeatureDTO } from '@/types/Feature';

export const getFeaturePlans = (): Promise<AxiosResponse<Feature>> => {
  return axios2.get('/customer-api/get-feature-plans');
};
